/*jshint esversion: 6 */
import React from 'react';
import CaBadgeView from "./general/CaBadgeView";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { firebaseConnect, getVal } from 'react-redux-firebase';
import _ from 'lodash';
import { getBadges } from '../helpers/computeBadges';

import {
    FacebookShareButton,
    FacebookIcon,
    TwitterShareButton,
    TwitterIcon
} from 'react-share';


class CaQuizResult extends React.Component {

    constructor(props) {
        super(props);
        this.state={
            loading: true,
            data: []
        };
    }
    
    getData() {
        return getBadges().then(res => res.badges.map(badge => {
            if (this.props.result.new_badges && this.props.result.new_badges[badge.id])
                return {
                    badgeImg: badge.icon,
                    badgeName: badge.name,
                    badgeDescription: badge.description
                }
            else
                return null;
        }).filter(r => r));
    }

    componentDidMount() {
        this.getData().then(data => this.setState({data, loading: false}));
    }


    render() {
        const {isSingleFreeTextQuiz, thankYouText} = this.props;

        return(
            <div className={"QuizComponentView QuizComponentView--alignMiddle QuizResult"}>
                <div className={"QuizComponentView__content QuizComponentView__content--alignMiddle"}>
                    { isSingleFreeTextQuiz && <h2 className={"QuizResult__score"}>{thankYouText}</h2> }
                    { !isSingleFreeTextQuiz && this.getTopBlock() }
                    { this.getContent() }
                </div>
            </div>
        )
    }


    getTopBlock() {
        const {header, shareHeader, scoreText, points, maxPoints} = this.props;

        return (
            <div className={"QuizResult__topBlock"}>
                <div className={"QuizResult__header"}>
                    <h3 className={"QuizResult__headerText"}>{header}</h3>
                    <h2 className={"QuizResult__score"}>{points} {scoreText} {maxPoints}</h2>
                </div>
                <div className={"QuizResult__share"}>
                    <h3 className={"QuizResult__headerText"}>{shareHeader}</h3>
                    <div className={"QuizResult__shareWrapper"}>

                        <FacebookShareButton
                            url={this.props.shareUrl}
                            quote={this.props.shareTitle}
                            className={"QuizResult__shareIcon"}
                            >
                            <FacebookIcon
                                size={32}
                                round />
                        </FacebookShareButton>
                        <TwitterShareButton
                            url={this.props.shareUrl}
                            quote={this.props.shareTitle}
                            className={"QuizResult__shareIcon"}
                            >
                            <TwitterIcon
                                size={32}
                                round />
                        </TwitterShareButton>

                    </div>
                </div>

            </div>
        )
    }


    getBadge() {

        let badge =  this.state.data;

        return (
            <div className={"QuizResult__newBadge"}>
                <h3 className={"QuizResult__newBadgeTitle"}>{badge.header}</h3>

                <div className={"QuizResult__badges"}>
                    { badge.map((badge,i)=>(
                        <CaBadgeView
                            key={i}
                            classNamePrepend={"QuizResult__Badge"}
                            badgeImg={badge.badgeImg}
                            badgeName={badge.badgeName}
                            badgeDescription={badge.badgeDescription}
                        />
                    ))}
                </div>
            </div>
        )
    }
    getContent() {
        const {isSingleFreeTextQuiz} = this.props;
        const {title, body, submitCta, submitCallback, linkCta, linkCallback} = this.props.content;
        return(
            <div className={"QuizResult__bottomBlock"}>
                {this.getBadge()}

                { !!title && !isSingleFreeTextQuiz && (
                    <h2 className={"QuizResult__title"}>{title}</h2>
                )}

                { !!body && !isSingleFreeTextQuiz && (
                    <p className={"QuizResult__body"}>{body}</p>
                )}
                { !!linkCta && !!linkCallback && (
                    <div className={"QuizResult__ctaWrapper"}>
                        <a  className={"QuizResult__cta"} onClick={()=>linkCallback()}>{linkCta}</a>
                    </div>
                )}
                { !!submitCta && !!submitCallback && (
                    <div className={"QuizFeedback__buttonWrapper"}>
                        <button className={"QuizFeedback__submitButton"} onClick={()=>submitCallback()}>{submitCta}</button>
                    </div>
                )}
            </div>
        )
    }

}

export default compose(
    connect((state) => ({
        result: getVal(state.firebase, `data/quiz/${state.firebase.auth.uid}/`)
    }),{}),
    firebaseConnect((props, store) => [
        `quiz/${store.getState().firebase.auth.uid}`
    ]),
)(CaQuizResult);


